import { object, string } from 'yup';

export const initialValues = {
  phoneNumber: '',
  code: '',
};

export const validationSchema = [
  object().shape({
    phoneNumber: string()
      .required('error.input.required.phone')
      .matches(/^\+[0-9]{10,15}$/, 'error.input.phone'),
  }),
  object().shape({
    code: string().required('error.input.required').length(6, 'error.input.required'),
  }),
];
